import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';

import { STRIPE_API_KEY } from 'config.js';

import { colors } from '../foundations';

// Called on first render of this component rather than at module scope: at module scope every route that
// pulled this file into its bundle fetched js.stripe.com before anything was on screen, including the
// onboarding steps that never show a card field. Memoised, so Elements still sees one stable promise.
let stripePromise: ReturnType<typeof loadStripe> | null = null;

const getStripe = () => {
  if (!stripePromise) stripePromise = loadStripe(STRIPE_API_KEY);
  return stripePromise;
};

const fonts = [
  {
    family: 'Satoshi',
    src: 'url(https://d2alqht3442852.cloudfront.net/fonts/Satoshi-Variable.woff2)',
  },
];

type StripeElementsProps = {
  children: React.ReactNode;
};

export default function StripeElements({ children }: StripeElementsProps) {
  return (
    <Elements
      stripe={getStripe()}
      options={{
        fonts,
        appearance: {
          theme: 'night',
          labels: 'floating',
          variables: {
            // colors
            colorBackground: colors.$bg_tertiary,
            colorTextPlaceholder: colors.$text_secondary,
            colorDanger: colors.$attention,
            // font
            fontFamily: 'Satoshi, sans-serif',
            // spacing
            spacingUnit: '4px',
            // border
            borderRadius: '6px',
          },
          rules: {
            '.Error': { fontSize: '12px' },
          },
        },
      }}
    >
      {children}
    </Elements>
  );
}
